import { render } from "./newsinfo.vue?vue&type=template&id=344a1d2e&scoped=true"
import script from "./newsinfo.vue?vue&type=script&lang=js"
export * from "./newsinfo.vue?vue&type=script&lang=js"

import "./newsinfo.vue?vue&type=style&index=0&id=344a1d2e&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344a1d2e"]])

export default __exports__